import React from "react";

const stats = [
  {
    value: "60%",
    source: "of convicted burglars said they considered cameras when choosing a target, and over 40% would pick another house — University of North Carolina at Charlotte study of 422 incarcerated burglars.",
    take: "Cameras deter when they're visible at the approach. That's why we walk the property before we mount anything.",
  },
  {
    value: "3–7 p.m.",
    source: "was the peak window for residential burglary in 2024, and daytime break-ins outnumbered nighttime — FBI crime data.",
    take: "Most DIY systems are set up for night. Ours alert you while you're at work.",
  },
  {
    value: "$7,815",
    source: "average loss per burglary in 2024 — FBI crime data.",
    take: "A full camera-and-alarm install costs a fraction of one incident.",
  },
  {
    value: "37 million",
    source: "packages were stolen in the past year, about $222 each — Security.org 2025 Package Theft Report.",
    take: "This is the call we get most. A video doorbell is where most homeowners start.",
  },
  {
    value: "51%",
    source: "of smart-home device owners have had devices drop off Wi-Fi; it's been the top smart-home problem four years running — Parks Associates.",
    take: "We test signal at every camera location and flag weak spots before install day, so nothing goes up where it will drop offline.",
  },
  {
    value: "5–20%",
    source: "typical homeowners insurance discount for a monitored system; cameras alone usually earn the low end — industry guidance; confirm with your carrier.",
    take: "Door and window alarms plus monitoring are what move the discount.",
  },
];

const SurveillanceStats: React.FC = () => (
  <>
    {/* Stats sourced Oct 2026: UNC Charlotte/Kuhns burglar study; FBI 2024 via SafeWise; Security.org 2025 package theft report; Parks Associates 2024-25; SafeHome.org MA property crime. Re-verify annually. */}
    <section className="section" data-testid="surveillance-stats">
      <div className="container">
        <span className="eyebrow">WHY PEOPLE ADD CAMERAS</span>
        <h2>What the numbers say.</h2>
        <div className="tile-grid mt-5">
          {stats.map((stat) => (
            <div className="tile" key={stat.value}>
              <h3 style={{ fontSize: "clamp(1.75rem, 3vw, 2.5rem)", fontWeight: 800 }}>{stat.value}</h3>
              <p>{stat.source}</p>
              <p style={{ marginTop: "1rem" }}>{stat.take}</p>
            </div>
          ))}
        </div>
        <p className="mt-5">
          Central Massachusetts is not a high-crime area — burglaries statewide have fallen roughly 64% since 2011 — and we won't tell you otherwise. Most of what a home system catches day to day is deliveries, contractors, kids getting home, and the occasional raccoon. The point is that a well-placed system is now inexpensive relative to a single average loss, and it removes the guessing.
        </p>
      </div>
    </section>
  </>
);

export default SurveillanceStats;
